(function ($) {
    var domainCd = $("#hdndomainCD").val();
    window.onSignIn = onGoogleSignIn;
    window.gapi_callback = gapi_callback;
    var _mixpanelproperties = null;
    var isPrivacyConsentEnabled = $("#hdnGdprPreferences").attr("data-privacyconsentenabled") && JSON.parse($("#hdnGdprPreferences").attr("data-privacyconsentenabled").toLowerCase());
    var isBuilderUsageEventAllowed = $("#hdnIsBuilderUsageEventAllowed").length > 0 ? $("#hdnIsBuilderUsageEventAllowed").val() == "true" : false;
    var isRegistrationPopup = $("#hdnIsRegisterPage").length > 0 ? $("#hdnIsRegisterPage").val() == "true" : false;
    var janusLoginDefaultTargetUrl = $("#janusLoginDefaultTargetUrl").length > 0 ? $("#janusLoginDefaultTargetUrl").val() : "";
    var isJanusChangesEnabled = $('#hdnisJanusEnabled').length>0 ? $('#hdnisJanusEnabled').val() === 'true':false;

    var originatingUrl = location.href;
    if (janusLoginDefaultTargetUrl !== "") {
        var url = new URL(originatingUrl);
        var urlParams = new URLSearchParams(url.search);
        urlParams.set("targ", janusLoginDefaultTargetUrl);
        url.search = urlParams.toString();
        originatingUrl = url.toString();
    }

    function loadMixPanelProperties() {
        RB3.DesktopAnalytics.Ready(function () {
            analytics.ready(function () {
                if (typeof mixpanel != 'undefined' && typeof mixpanel.get_distinct_id != 'undefined') {
                    var infoProp = mixpanel._.info.properties();
                    var persistProps = mixpanel.persistence.properties();
                    _mixpanelproperties = JSON.stringify($.extend(infoProp, persistProps));
                    $("#MixpannelProperties").val(_mixpanelproperties);
                    var hdnEventProps = $('#hdnEventProps');
                    var isTimedOut = hdnEventProps.attr('isTimedOut');
                    if (isTimedOut && isTimedOut.toLowerCase() == 'true') {
                        var platformString = hdnEventProps.attr('data-platformString');
                        var webString = hdnEventProps.attr('data-webString');
                        var loginStatusString = hdnEventProps.attr('data-loginStatusString');
                        var timedoutEvent = hdnEventProps.attr('data-timeoutEvent');
                        var obj = {};
                        obj[platformString] = webString;
                        obj[loginStatusString] = 'FALSE';
                        var mixpanelPropertiesForTimeout = $.extend(infoProp, persistProps, obj);
                        mixpanelPropertiesForTimeout[RB3.Dom.Get("userSubscriptionStatus").attr('data-sub-status-name')] = RB3.Dom.Get("userSubscriptionStatus").attr('data-sub-status-value');
                        mixpanelPropertiesForTimeout[RB3.Dom.Get("userPaymentStatus").attr('data-payment-status-name')] = RB3.Dom.Get("userPaymentStatus").attr('data-payment-status-value');

                        RB3.DesktopAnalytics.Track(timedoutEvent, mixpanelPropertiesForTimeout, {
                            integrations: {
                                'All': false,
                                'Mixpanel': true,
                                'Webhooks': true,
                                'Webhook': true,
                                'Webhook (Actions)': true
                            }
                        });
                    }
                }
            });
        });
    }
    function GASignedUp(userId) {
        RB3.DesktopAnalytics.Ready(function () {
            RB3.DesktopAnalytics.FireGACustomEvent('registrations', 'ga sign up');
        });
    }
    function validateEmail() {
        $("#errEmailReqMsg,#errEmailValidMsg,.error-message").hide();
        var contactEmail = $("#UserName").val();
        if (!contactEmail) {
            $("#errEmailReqMsg").show();
            $("#UserName").parent('.input-element').addClass("invalid").removeClass("valid");
            return false;
        }
        if (contactEmail && !RB3.Validation.VerifyEmail(contactEmail)) {
            $("#errEmailValidMsg").show();
            $("#UserName").parent('.input-element').removeClass("valid").addClass("invalid");
            return false;
        }
        $("#UserName").parent('.input-element').removeClass("invalid").addClass("valid");
        return true;
    }
    function validatePwd() {

        $("#errPwdReq,#errPwdLength").hide();
        var pwd = $.trim($("#Password").val());
        if (!pwd) {
            $("#errPwdReq").show();
            $("#Password").parent('.input-element').addClass("invalid").removeClass("valid");
            return false;
        }
        else if (pwd.length == 20) {
            $("#errPwdLength").show();
            $("#Password").parent('.input-element').addClass("invalid").removeClass("valid");
            return false;
        }

        else if (pwd.length < 6) {
            $("#LoginError").text($('#invalidLengthPasswordMsz').val());
            //$("#Password").parent('.input-element').addClass("invalid").removeClass("valid");
            return false;
        }

        $("#Password").parent('.input-element').removeClass("invalid").addClass("valid");
        return true;
    }
    function validate() {
        var isValid = true;
        if (!validateEmail()) { isValid = false; return isValid; }
        if (!validatePwd()) { isValid = false; }
        return isValid;
    }
    function decorateUrl(urlString) {
        var ga = window[window['GoogleAnalyticsObject']];
        var tracker;
        if (ga && typeof ga.getAll === 'function') {
            tracker = ga.getAll()[0]; // Uses the first tracker created on the page
            urlString = (new window.gaplugins.Linker(tracker)).decorate(urlString);
        }
        return urlString;
    }

    function decodeJwtResponse(data) {
        var tokens = data.split(".");
        return JSON.parse(atob(tokens[1]));
    }

    function ExecuteGoogleSignInRH(registrationDetails) {
        RB3.Ajax.Post({
            url: RB3.Urls.Get("googleSignInUrl"),
            disableLoader: false,
            data: { userDetails: registrationDetails, mixpanelProperties: _mixpanelproperties },
        }).then(function (result) {
            var obj = result;
            var userid = parseInt(obj.userId);
            var errorMessage = obj.errorMessage;
            var userType = obj.userType;
            var nextUrl = obj.nextUrl;
            var isCrossDomainLogin = obj.isCrossDomainLoginCase;
            if (isCrossDomainLogin) {
                $('#lnk-cross-login').attr('href', obj.autologinUrl);
                $('#popup-cross-login').addClass('visible');
                $('#lnk-cross-login').on('click', function () {
                    RB3.DesktopAnalytics.FireCrossLoginEvent(obj.userId, obj.targetPortal, obj.sourcePortal)
                });
            }
            if (errorMessage === '') {
                if (userType == 'N' && userid > 0) {
                    RB3.User.SetUserStage($('#hdnRegisteredA').val(), false, -1);
                    GASignedUp(userid);
                    FireSmartLookEvent(userid, registrationDetails.email);
                }
                RB3.DesktopAnalytics.Ready(function () {
                    analytics.ready(function () {
                        RB3.DesktopAnalytics.Identify(userid, {});
                    });
                });
                location.href = nextUrl;
            }
            else {
                $("#LoginError").text(errorMessage);
                $("#LoginError").show();
            }
        });
    }

    function onGoogleSignIn(response) {
        //if (document.getElementById('googleSignInBtn').getAttribute('data-me-clicked') !== 'true') {
        //    if (gapi != undefined)
        //        gapi.auth2.getAuthInstance().signOut();
        //    return;
        //} else {
        //    document.getElementById('googleSignInBtn').setAttribute('data-me-clicked', 'false');
        //}

        var responsePayload = decodeJwtResponse(response.credential);
        var Email = responsePayload.email;
        var emailOptOut = $("#hdnEmailOptOut").val();
        var hdnRhio = $('#isRhIO');
        var gaId = '';
        var directRedirectToJanus = $('#hdnisJanusRedirect').val().toLowerCase() == 'true';
        var isLoginOnly = domainCd.toLowerCase() == "rgu"; //should be false for hardcoded janus, for google sign in
        if (hdnRhio.length > 0 && hdnRhio.val().toLowerCase() == 'true')
            gaId = setGAId();
        if (domainCd.toLowerCase() == "rhk" || domainCd.toLowerCase() == "rhs") {
            isLoginOnly = !directRedirectToJanus;
        }
        
        if (Email != "") {
            //loadMixPanelProperties();
            var registrationDetails = {
                documentId: -1,
                email: Email,
                parentUid: responsePayload.sub,
                accessToken: response.credential,
                fullName: responsePayload.name,
                optOut: emailOptOut,
                rememberMe: $("#RememberMe").val() == 'true' ? true : false,
                GaId: gaId
            };
                RB3.Ajax.Get({
                    url: RB3.Urls.Get("countryCdCheckAndUpdate").replace("abc", Email),
                    async:false
                }).then(function () {
                });
            var isDotnetBuilder = $('#hdnisDotnetBuilder').val().toLowerCase() == 'true';
            if (isJanusChangesEnabled && directRedirectToJanus) {
                HPLOGIN.Accounts.loginGoogle(originatingUrl, domainCd, "Resume", null, null, null, null, isLoginOnly).then(function (data) {
                    var redirectURL = data && data.redirectUrl ? data.redirectUrl : "";
                    if (data && data.status == "EXISTING_USER") {
                        typeof headerfooter == 'object' && typeof headerfooter.loginuser == 'function' && headerfooter.loginuser();
                        if (location.href == redirectURL) {
                            typeof postLoginMethod == 'function' && postLoginMethod(redirectURL, data.userid, redirectURL);
                        } else {
                            window.location.replace(redirectURL);
                            return;
                        }
                    }
                    else if (data && data.status == "NEWLY_CREATED") {
                        //typeof postRegisterMethod == 'function' && postRegisterMethod(true, redirectURL, data.userid, redirectURL);
                       // RG-17823 fixing redirect issue for newly created user
                        window.location.replace(redirectURL);
                        return;
                    }
                });
            }
              //commented because now we are hardcoding ALL intl and RH portal login except RGU
            else if (isJanusChangesEnabled && isDotnetBuilder) {
                try {
                    RB3.Ajax.Get({
                        url: RB3.Urls.Get("isValidJanusUser").replace("123", encodeURIComponent(Email)),
                        disableLoader: true
                    }).then(function (value) {
                        if (value) {                            
                            HPLOGIN.Accounts.loginGoogle(originatingUrl, domainCd, "Resume", null, null, null, null, isLoginOnly).then(function (response) {
                                if (response && response.status == "EXISTING_USER") {                                   
                                    location.href = response.redirectUrl;    
                         }
                            });
                        }
                        else { ExecuteGoogleSignInRH(registrationDetails); }
                    });
                }
                catch (e) {
                    ExecuteGoogleSignInRH(registrationDetails);
                }
            }
            else {
                ExecuteGoogleSignInRH(registrationDetails);
            }     
        }
    }
    function FireSmartLookEvent(uid, email) {
        var privacyConsent = JSON.parse(localStorage.getItem("privacy_consent"));;

        if ((isPrivacyConsentEnabled && privacyConsent && privacyConsent.p_anl) || !isPrivacyConsentEnabled) {
            RB3.Plugin("smartlook").Ready(function () {
                var eventName = 'loaded user registration';
                var properties = {
                    "user id": uid,
                    "email": email
                };
                smartlook('identify', RB3.Utility.GetCookie("_hptd"), {
                    "user id": uid,
                    "email": email
                });
                smartlook('track', eventName, properties);
            });
        }
    }
    $("#googleSignInBtn").on("click", googleSignBtnClick);
    function googleSignBtnClick(e) {
        $(this).attr('data-me-clicked', 'true');
        if (isBuilderUsageEventAllowed) {        
            if (isRegistrationPopup) {
                RB3.MixpanelTag.TrackCTAClick("Register", "register with google");
            }
            else {
                RB3.MixpanelTag.TrackCTAClick("Login", "login with google");
            }
        }
    }
    function setGAId() {
        var url = "abc";
        url = decorateUrl(url);
        var arr = url.split('?');
        var gaQuerystring = '';
        if (arr.length > 0) {
            gaQuerystring = arr[1];
            $('#hdnGaId').val(gaQuerystring);
        }
        return gaQuerystring;
    }

    function loginUser(e) {
        if (e && e.preventDefault) { e.preventDefault(); }
        var errorMessage = "";
        if (validate()) {
            var rememberMe = $("#RememberMe:checked").length > 0 ? 1 : 0;
            var signInDetails = {
                UserName: $.trim($("#UserName").val()),
                Password: $("#Password").val(),
                RememberMe: rememberMe,
                MixpannelProperties: _mixpanelproperties
            };
                RB3.Ajax.Get({
                    url: RB3.Urls.Get("countryCdCheckAndUpdate").replace("abc", signInDetails.UserName),
                    async:false
                }).then(function () {
                });
            var directRedirectToJanus = $('#hdnisJanusRedirect').val().toLowerCase() == 'true';
            var isDotnetBuilder = $('#hdnisDotnetBuilder').val().toLowerCase() == 'true';
            if (isJanusChangesEnabled && directRedirectToJanus) {
                HPLOGIN.Accounts.loginUser(signInDetails.UserName, signInDetails.Password, null, null, 0, null, null, null, null, null, originatingUrl, false, false).then(function (data) {
                    if (data && (data.status == "NEWLY_CREATED" || data.status == "SUCCESS" || data.status == "EXISTING_USER" || data.status == "USER_SWAP") && data.userid != "" && data.userid != null) {
                        var redirectURL = data.redirectUrl;
                        typeof headerfooter == 'object' && typeof headerfooter.loginuser == 'function' && headerfooter.loginuser();
                        if (location.href == redirectURL) {
                            if (data.status == "NEWLY_CREATED") {
                                typeof postRegisterMethod == 'function' && postRegisterMethod(true, redirectURL, data.userid, (data.redirectUrl ? data.redirectUrl : ""));
                            }
                            else {
                                typeof postLoginMethod == 'function' && postLoginMethod(redirectURL, data.userid, (data.redirectUrl ? data.redirectUrl : ""));
                            }
                        } else {
                            window.location.replace(redirectURL);
                            return;
                        }
                    }
                    else if (data && data.status == "INVALID_PASSWORD") {
                        $("#LoginError").text($('#invalidPasswordMsz').val());
                    }
                    else if (data && data.status == "PASSWORD_EXPIRED") {
                        alert("Your password has expired. We have sent you an email to reset your password. Please check your email and follow the directions provided to retrieve your password.");
                    }
                    else {
                        //Fallabck for production swap for existing user which is on dotnet funnel at that time phrase
                        ExecuteLogin(signInDetails);
                    }
                }, function () {
                });
            }
            else if (isJanusChangesEnabled && isDotnetBuilder) {
                try {                   
                    RB3.Ajax.Get({
                        url: RB3.Urls.Get("isValidJanusUser").replace("123", encodeURIComponent(signInDetails.UserName)),
                        disableLoader: true
                    }).then(function (value) {
                        if (value) {
                            HPLOGIN.Accounts.loginUser(signInDetails.UserName, signInDetails.Password, null, null, 0, null, null, null, null, null, originatingUrl, false, false).then(function (data) {
                                if (data && (data.status == "NEWLY_CREATED" || data.status == "SUCCESS" || data.status == "EXISTING_USER" || data.status == "USER_SWAP") && data.userid != "" && data.userid != null) {
                                    var redirectURL = data.redirectUrl;
                                    typeof headerfooter == 'object' && typeof headerfooter.loginuser == 'function' && headerfooter.loginuser();
                                    if (location.href == redirectURL) {
                                        if (data.status == "NEWLY_CREATED") {
                                            typeof postRegisterMethod == 'function' && postRegisterMethod(true, redirectURL, data.userid, (data.redirectUrl ? data.redirectUrl : ""));
                                        }
                                        else {
                                            typeof postLoginMethod == 'function' && postLoginMethod(redirectURL, data.userid, (data.redirectUrl ? data.redirectUrl : ""));
                                        }
                                    } else {
                                        window.location.replace(redirectURL);
                                        return;
                                    }
                                }
                                else if (data && data.status == "INVALID_PASSWORD") {
                                    $("#LoginError").text("Sorry, the password you entered is incorrect");
                                }
                                else if (data && data.status == "PASSWORD_EXPIRED") {
                                    alert("Your password has expired. We have sent you an email to reset your password. Please check your email and follow the directions provided to retrieve your password.");
                                }
                                else {
                                    ExecuteLogin(signInDetails);
                                }
                            }, function () {
                            });
                        }
                        else { ExecuteLogin(signInDetails); }
                    });
                }
                catch (e) {
                    ExecuteLogin(signInDetails);
                }
            }
            else { ExecuteLogin(signInDetails); }
        }
    }

    function ExecuteLogin(signInDetails) {
        RB3.Ajax.Post({
            url: RB3.Urls.Get("signInAjaxUrl"),
            data: signInDetails
        }).then(function (response) {
            errorMessage = response.errormessage;
            var nextUrl = response.nextUrl;
            var isCrossDomainLogin = response.isCrossDomainLoginCase;
            if (isCrossDomainLogin) {
                $('#lnk-cross-login').attr('href', response.autologinUrl);
                $('#popup-cross-login').addClass('visible');
                $('#lnk-cross-login').on('click', function () {

                    RB3.DesktopAnalytics.FireCrossLoginEvent(response.userId, response.targetPortal, response.sourcePortal)
                });
            }
            else if (errorMessage == null || errorMessage === '') {
                location.href = nextUrl;
            }
            else {
                $("#LoginError").text(errorMessage);
            }
        });
    }

    function ready() {
        loadMixPanelProperties();
        if (isBuilderUsageEventAllowed) {
            RB3.MixpanelTag.TrackPageViewed();
            if ($("#RememberMe").is(":checked")) {
                RB3.MixpanelTag.TrackCTAClick("Login", "clicked keep me logged in");
            }
            else {
                RB3.MixpanelTag.TrackCTAClick("Login", "unclicked keep me logged in");
            }
        }
        $("#UserName").on("blur", function () { validateEmail(); });
        $("#Password").on("blur", function () { validatePwd(); });
        $("#loginSubmit").on("click", function (e) {
            if (isBuilderUsageEventAllowed) {
                if (isRegistrationPopup) {
                    RB3.MixpanelTag.TrackCTAClick("Register");
                }
                else {
                    RB3.MixpanelTag.TrackCTAClick("Login");
                }
            }
            $("#LoginError").text('');
            var hdnRhio = $('#isRhIO');
            if (hdnRhio.length > 0 && hdnRhio.val().toLowerCase() == 'true')
                setGAId();
            if (!isRegistrationPopup) {
                loginUser(e);
            }
        });

        $("#RememberMe").on("change", function () {
            if (!isBuilderUsageEventAllowed) return;
            if ($(this).is(":checked")) {
                RB3.MixpanelTag.TrackCTAClick("Login", "clicked keep me logged in");
            }
            else {
                RB3.MixpanelTag.TrackCTAClick("Login", "unclicked keep me logged in");
            }
        })

        $("#linkForgotPassword").on("click", function () {
            if (isBuilderUsageEventAllowed) {
                RB3.MixpanelTag.TrackCTAClick("Login","forgot your password");
            }
        });

        $("#linkNewHereCreateAccount").on("click", function () {
            if (isBuilderUsageEventAllowed) {
                if (isRegistrationPopup) {
                    RB3.MixpanelTag.TrackCTAClick("Register", "clicks new here?create an account");
                }
                else {
                    RB3.MixpanelTag.TrackCTAClick("Login", "clicks new here?create an account");
                }
            }
        });
    }
    //callback method of google SSO library to customize sign button
    function gapi_callback() {
        $('span[id^="not_signed_"]').html($('#hdngsignintext').val());
        $('span[id^="connected"]').html($('#hdngloggedintext').val());
    }
    $(ready);
})(jQuery);